<template>
  <path pid="0" d="M18.66 6.93a1 1 0 000 1.42 8 8 0 11-11.32 0 1 1 0 000-1.42 1 1 0 00-1.41 0 10 10 0 1014.14 0 1 1 0 00-1.41 0z"/><path pid="1" d="M14 13V3a1 1 0 10-2 0v10a1 1 0 002 0z"/>
</template>
